import { DateTime } from 'luxon';
import { dayOfWeekOrder } from '../days-multiple-select-field/days-multiple-select-field.utils';
import { Schedule } from './scheduler-field.context';

// Sort the array by starting time
const sortByStartTime = (array, timeFormat) => {
  array.sort((a, b) => {
    const startTimeA = DateTime.fromFormat(a.startTime, timeFormat);
    const startTimeB = DateTime.fromFormat(b.startTime, timeFormat);

    const diff = startTimeA.diff(startTimeB).as('milliseconds');
    return diff > 0 ? 1 : -1;
  });
};

export const groupAndSortRecordsByDaysOfWeek = (
  schedules: Schedule[],
  timeFormat: string,
) => {
  // Group the data by 'daysOfWeek'
  const groupedData: { [key: string]: typeof schedules } = {};
  schedules.forEach(item => {
    if (!groupedData[item.day]) {
      groupedData[item.day] = [];
    }
    groupedData[item.day].push(item);
  });

  // Sort the grouped data based on weekdays order
  const sortedGroupedDataByWeekDays = Object.entries(groupedData)
    .sort(
      ([a], [b]) =>
        dayOfWeekOrder.findIndex(day => day === a) -
        dayOfWeekOrder.findIndex(day => day === b),
    )
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {} as typeof groupedData);

  for (const key in sortedGroupedDataByWeekDays) {
    sortByStartTime(sortedGroupedDataByWeekDays[key], timeFormat);
  }

  return sortedGroupedDataByWeekDays;
};

export const capitalizeDayOfWeek = (dayOfWeek: string) => {
  return dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1).toLowerCase();
};
